import {useCallback} from 'react';
import {useDispatch} from 'react-redux';

import {useCachedTable} from 'src/hooks/common-data-service/cached-table';
import {getUsersNewsletters} from 'src/openapi/admin/apis/GetUsersNewslettersApi';
import {useAppDispatch} from 'src/store/hooks';

import {
    userSearchResultNewslettersActions,
    userSearchResultNewslettersDataSelector,
    userSearchResultNewslettersResultSelector,
} from '../slices/user-search-result-newsletters.slice';
import {userSearchResultStateSelector} from '../slices/user-search-result-state.slice';

import type {UserSearchResultCacheKeys} from '../typedef';


type Props = {
    userIds: number[],
    totalCount: number,
};

export const useGetUserSearchResultNewsletters = ({userIds, totalCount}: Props) => {
    const apiDispatch = useAppDispatch();
    const dispatch = useDispatch();

    const getAction = useCallback((cachedKeys: UserSearchResultCacheKeys) => apiDispatch(getUsersNewsletters({
        getNewslettersRequest: {userIds, sortDirection: cachedKeys.sortCriteria.direction || 'ASC'},
    })), [userIds, apiDispatch]);

    const setLoadedData = useCallback((
        response: Record<string, string[]>,
        dataCacheKeys: UserSearchResultCacheKeys,
    ) => {
        dispatch(userSearchResultNewslettersActions.onSuccess(({
            cacheKeys: dataCacheKeys,
            totalCount,
            data: response,
        })));
    }, [totalCount, dispatch]);

    return useCachedTable({
        dataSelector: userSearchResultNewslettersDataSelector,
        stateSelector: userSearchResultStateSelector,
        resultSelector: userSearchResultNewslettersResultSelector,
        actions: userSearchResultNewslettersActions,
        getAction,
        onSuccessLoad: setLoadedData,
        shouldClearOnUnmount: false,
    });
};
